import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { LicenseEffects } from "./+state/effects";
import { LicenseFacade } from "./+state/facades";
import { LICENSE_FEATURE_KEY, licenseReducer } from "./+state/reducers";
import { LicenseService } from "./+state/services";

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([LicenseEffects]),
    StoreModule.forFeature(LICENSE_FEATURE_KEY, licenseReducer)
  ],
  providers: [LicenseFacade, LicenseService]
})
export class LicenseDataAccessModule {}
